module.exports = __webpack_public_path__ + "assets/img/modal-avatar-3163db75.png";